exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px){.styles--onlyXs__1SdcC{display:none !important}}@media (min-width: 768px){.styles--smUp__2tLPt{display:none !important}}@media (max-width: 999px){.styles--mdDown__hmDdn{display:none !important}}.styles--iconBox__2nBqQ{position:relative;width:96px;height:60px}@media (max-width: 767px){.styles--iconBox__2nBqQ{width:40px;height:40px}}.styles--iconBox__2nBqQ>.svgicon{position:absolute;margin:auto;top:-99px;right:-99px;bottom:-99px;left:-99px}\n", ""]);

// exports
exports.locals = {
	"onlyXs": "styles--onlyXs__1SdcC",
	"smUp": "styles--smUp__2tLPt",
	"mdDown": "styles--mdDown__hmDdn",
	"iconBox": "styles--iconBox__2nBqQ"
};